import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AboutAuth from "../../components/UI/AboutAuth";
import AboutPageAudioEditor from "./AboutPageAudioEditor";
import TranscribeAudioAbout from "../../components/TranscribeAudio2/TranscribeAudioAbout";
import PdfToTextAbout from "../../components/PdfToText/PdfToTextAbout";

import { useStore } from "../../hook-store/store";

import AboutPageImage1 from "../../images/audio-tools-image-crop-h200.jpg";
import AboutPageImage2 from "../../images/cloud-sync-crop-h200.png";

import { kuraStorageLink } from '../../App';

import { marks } from "../../utils/marks";
import './AboutPage.css';

const AboutPage = (props) => {

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  const { isAuth } = store.uiStore;

  useEffect(() => {
    window.scrollTo(0, 0);
  },[]);

  return (
    <Fragment>
      <div>
        <div className="aboutPageTitle">
          Kura Text Audio Tools
        </div>

        <div className="aboutPageTopImages">
          <div>
            <img className="aboutPageTopImage"
              src={AboutPageImage1}
            />
          </div>
          <div>
            <img className="aboutPageTopImage"
              src={AboutPageImage2}
            />
          </div>
        </div>
        <p>
          Kura Text Audio Tools
          {' '}
          {t('aboutPage.16', 'provide tools for handling text and audio data.')}
        </p>
        <p>
        {t('aboutPage.17', 'The tools inclede')}
          {' '}
          <strong>
            Audio Transcriber, Voice Generator, Text Voice Assistant, Answer Finder, Video to Audio.
          </strong>
        </p>
        <br/>

        <p>
          In <strong>Audio transcriber,</strong> 
          {' '}
          {t('aboutPage.18', 'by using advanced AI-technologies, user can generate text transcript from audio sources such as audio file, video file, and recorded voices.')}
        </p>
        <p>
          {t('aboutPage.29', 'It creates files for subtitles from audio or video as well.')}
        </p>
        <p>
          {t('aboutPage.19', 'It is possible to choose a language for generating text from more than 90 different languages.')}
          {' '}
          {marks.fileAudioOMark}{marks.fileVideoOMark} {`-->`} {marks.fileTextOMark} 
        </p>
        <br/>
        
        <p>
          In <strong>Voice generator,</strong> 
          {' '}
          {t('aboutPage.20', 'user can generate audio from text input.')} 
        </p>
        <p>
        {t('aboutPage.21', 'User can control output audio speed and select voices from more than 900 different voices.')}
        {' '}
        {' '}
        {marks.fileTextOMark} {`-->`} {marks.fileAudioOMark} 
        {/* {t('aboutPage.25', 'Supported language is English.')} */}
        </p>
        <br/>

        <p>
          In <strong>Text Voice Assistant</strong>,
          {' '}
          {t("textVoiceAssistant10", "user can ask questions to AI assistant by using text input or voice input.")}
        </p>
        <p>
          {marks.editMark} {marks.volumeUpMark} {`-->`} {marks.fileTextOMark} {marks.volumeUpMark}
        </p>
        <br/>

        <p>
          In <strong>Answer Finder,</strong> 
          {' '}
          {t('aboutPage.22', 'User can find an answer in text context by asking question.')}
          {' '}
          {/* {t('aboutPage.25', 'Supported language is English.')} */}
        </p>
        <br/>

        <AboutPageAudioEditor />
        <br/>
        
        <p>
          <strong>Video to Audio</strong> 
          {' '}
          <div className="paraSection">
            <strong>
              Video to Audio {marks.fileVideoOMark} {`-->`} {marks.fileAudioOMark} :
            </strong>
              {' '}
              {t('aboutPage.26', 'audio file is created from video file.')}
              {' '}
              {t('aboutPage.27', 'Audio data are extracted from video file, and audio file is created using the audio data.')}
              {' '}
          </div>
          <div className="paraSection">
            <strong>
              Convert to MP4 {marks.fileVideoOMark} {marks.exchangeMark} {marks.fileVideoOMark} : 
            </strong>{' '}
            {t('videoToAudio14', 'user can change video file format to mp4 video file')}.
            {' '}             
          </div>
        </p>
        {/* <p>
          In <strong>Video to Audio,</strong> 
          {' '}
          {t('aboutPage.26', 'audio file is created from video file.')}
          {' '}
          {t('aboutPage.27', 'Audio data are extracted from video file, and audio file is created using the audio data.')}
          {' '}
          <br/>
          {marks.fileVideoOMark} {`-->`} {marks.fileAudioOMark}
          <br/>
            In <strong>Convert to MP4</strong> 
            {' '}(in Video to Audio),{' '}
            {t('videoToAudio14', 'user can change video file format to mp4 video file')}.
            {' '}
            {t('aboutPage.28', 'User can download the file or upload the file')} 
            {' '}to{' '}
            <a href={`${kuraStorageLink}/about`}
              target="_blank" rel="noopener noreferrer"
            >
              <strong>Kura Storage</strong>
            </a>. 
            <br/>
            {marks.fileVideoOMark} {marks.exchangeMark} {marks.fileVideoOMark}
        </p> */}
        <br/>

        <p>
          <strong>PDF to text</strong>
        </p>
        <PdfToTextAbout />
        <br/>

        <p>
          {t('aboutPage.23', 'Generated audio and text data can be stored')} 
          {' '}
          at{' '} 
          <a href={`${kuraStorageLink}/about`}
            target="_blank" rel="noopener noreferrer"
          >
            <strong>Kura Storage</strong>
          </a>.
          {' '}
          {t('aboutPage.24', 'These files can be accessed from both desktop and mobile devices for later usage.')}
        </p>

        <br/>
        {!isAuth && (
          <AboutAuth />
        )}
      </div>
    </Fragment>
  );
};
export default AboutPage;
